var REACT_PORTAL_SECTION_ID = 'reactPortalSection';

export { REACT_PORTAL_SECTION_ID };
